import React, { Children } from 'react';
import { CheckCircle2, CreditCard, Smartphone, ShieldCheck, Lock, Zap, Users, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export function CheckoutPage() {
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-yellow-400 selection:text-black" data-id="element-3">
      <div className="max-w-2xl mx-auto px-6 pt-6 pb-12 md:pt-10 md:pb-20 text-center" data-id="element-4">
        {/* Hero Section */}
        <motion.header initial="hidden" animate="visible" variants={containerVariants} className="mb-6" data-id="element-5">
          <motion.div variants={itemVariants} className="inline-block px-4 py-1.5 mb-3 rounded-full bg-yellow-400/10 border border-yellow-400/20 text-yellow-400 text-sm font-medium tracking-wide uppercase" data-id="element-6">
            Paso Final: Activa tu Acceso
          </motion.div>
          <motion.h1 variants={itemVariants} className="md:text-5xl mb-4 tracking-tight text-[24px] font-[800]" data-id="element-7">
            👉 Estás a un paso de acompañar esta etapa con claridad y
            tranquilidad
          </motion.h1>
          <motion.p variants={itemVariants} className="md:text-xl text-gray-400 max-w-lg mx-auto text-[16px]" data-id="element-8">
            Empieza hoy mismo a acompañar esta etapa con claridad, sin sentirte
            perdido ni improvisar
          </motion.p>
        </motion.header>

        {/* Trust Block */}
        <motion.div initial="hidden" animate="visible" variants={containerVariants} className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-8 py-2 px-4 rounded-full bg-white/5 border border-white/10 w-fit mx-auto" data-id="element-9">
          {[{
          icon: Zap,
          text: 'Acceso inmediato'
        }, {
          icon: Award,
          text: 'Garantía de 7 días'
        }, {
          icon: Users,
          text: '+2,000 familias ya lo usan'
        }].map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-center gap-1.5" data-id="element-10">
              <item.icon className="w-4 h-4 text-yellow-400" data-id="element-11" />
              <span className="text-xs font-medium text-gray-300 whitespace-nowrap" data-id="element-12">
                {item.text}
              </span>
            </motion.div>)}
        </motion.div>

        {/* Selection Title */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="mb-8" data-id="element-13">
          <h2 className="text-2xl font-bold mb-2" data-id="element-14">
            Elige cómo quieres activar tu acceso y recibe tu MegaPack
          </h2>
          <div className="w-12 h-1 bg-yellow-400 mx-auto rounded-full" data-id="element-15"></div>
        </motion.div>

        {/* Payment Options */}
        <div className="space-y-6 mb-8" data-id="element-16">
          {/* Featured Option: Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="relative group" data-id="element-17">
            <div className="absolute -inset-0.5 bg-yellow-400 rounded-3xl blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-18"></div>
            <div className="relative bg-[#111] border-2 border-yellow-400 rounded-3xl p-8 md:p-10" data-id="element-19">
              <div className="flex justify-between items-start mb-6" data-id="element-20">
                <div className="text-left" data-id="element-21">
                  <h3 className="text-2xl font-bold mb-1" data-id="element-22">Pago con tarjeta</h3>
                  <p className="text-yellow-400 text-sm font-semibold uppercase tracking-wider" data-id="element-23">
                    Opción más rápida
                  </p>
                </div>
                <CreditCard className="w-10 h-10 text-yellow-400" data-id="element-24" />
              </div>

              <ul className="text-left space-y-4 mb-8" data-id="element-25">
                {['Procesamiento instantáneo y seguro', 'Acceso automático a tu correo', 'Empiezas a aplicarlo hoy mismo'].map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-26">
                    <CheckCircle2 className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" data-id="element-27" />
                    <span className="text-gray-300" data-id="element-28">{benefit}</span>
                  </li>)}
              </ul>

              <a href="https://peru.recursodigital.shop/cart/52215675453733:1" target="_blank" rel="noopener noreferrer" className="block w-full py-5 bg-yellow-400 hover:bg-yellow-300 text-black rounded-2xl transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(250,204,21,0.3)] uppercase tracking-tight text-[16px] font-[800] text-center" data-id="element-29">
                ACCEDER AHORA CON TARJETA
              </a>
            </div>
          </motion.div>

          {/* Secondary Option: Yape/Other */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-[#111] border border-white/10 rounded-3xl p-8 md:p-10 hover:border-white/20 transition-colors" data-id="element-30">
            <div className="flex justify-between items-start mb-6" data-id="element-31">
              <div className="text-left" data-id="element-32">
                <h3 className="text-2xl font-bold mb-1" data-id="element-33">
                  Pago con Yape u otros métodos
                </h3>
                <p className="text-sm text-[#B52BB5]" data-id="element-34">
                  La opción más usada en Perú 🇵🇪
                </p>
              </div>
              <Smartphone className="w-10 h-10 text-gray-400" data-id="element-35" />
            </div>

            <ul className="text-left space-y-4 mb-8" data-id="element-36">
              {['Paga fácil con Yape', 'Sin necesidad de tarjeta', 'Activación rápida y guiada'].map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-37">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" data-id="element-38" />
                  <span className="text-gray-400" data-id="element-39">{benefit}</span>
                </li>)}
            </ul>

            <a href="https://pay.hotmart.com/P105301596E" target="_blank" rel="noopener noreferrer" className="block w-full py-5 hover:bg-white/10 text-white border border-white/20 rounded-2xl transition-all uppercase tracking-tight bg-[#4D1669] text-[16px] font-[800] text-center" data-id="element-40">
              ACCEDER CON YAPE AHORA
            </a>
          </motion.div>
        </div>

        {/* Guarantee Section */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center gap-6 mb-12 py-6 border-t border-white/5" data-id="element-41">
          <div className="flex items-center gap-4" data-id="element-42">
            <ShieldCheck className="w-16 h-16 text-yellow-400/80" data-id="element-43" />
            <div className="text-left" data-id="element-44">
              <h4 className="text-xl font-bold" data-id="element-45">Garantía de Satisfacción</h4>
              <p className="text-gray-400 text-sm max-w-xs" data-id="element-46">
                Tienes 7 días para probar el contenido. Si no es lo que
                esperabas, te devolvemos el 100% de tu dinero.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-500 uppercase tracking-widest" data-id="element-47">
            <Lock className="w-3 h-3" data-id="element-48" />
            <span data-id="element-49">Transacción encriptada y 100% segura</span>
          </div>
        </motion.div>

        {/* Footer */}
        <footer className="text-gray-500 text-sm font-medium pb-8" data-id="element-50">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-51">
            <span data-id="element-52">Acceso inmediato</span>
            <span className="hidden md:inline text-white/10" data-id="element-53">|</span>
            <span data-id="element-54">100% digital</span>
            <span className="hidden md:inline text-white/10" data-id="element-55">|</span>
            <span data-id="element-56">Pago seguro</span>
          </div>
        </footer>
      </div>
    </div>;
}